import { useState } from "react";

interface Props{
    onRefetchData: () => Promise<void>;
    onClose:VoidFunction
}

const useRiderScanToConfirm=({onRefetchData,onClose}:Props)=>{
    // variables
    const [loading,setLoading]=useState<boolean>(false);

    const handleClickDoneButton=async ()=>{
        try{
            setLoading(true);
            await onRefetchData();
            onClose();
        }catch(err){
            window.alert("Server error please try again");
        }finally{
            setLoading(false);
        }
    }
    return {
        loading,
        handleClickDoneButton
    }
}
export default useRiderScanToConfirm;